const startOfDay = (value) => {
  const d = new Date(value);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const daysUntilDeparture = (bookingDate, departureDate) => {
  if (!bookingDate || !departureDate) return null;
  const booking = startOfDay(bookingDate);
  const departure = startOfDay(departureDate);
  const diffMs = departure.getTime() - booking.getTime();
  return Math.max(0, Math.floor(diffMs / (24 * 60 * 60 * 1000)));
};

export const resolveApplicableInstallments = (installments, daysRemaining) => {
  if (!Array.isArray(installments) || installments.length === 0) return [];

  if (daysRemaining == null) return [...installments];

  const applicable = installments
    .filter(
      (inst) =>
        inst.days_before_departure != null &&
        Number(inst.days_before_departure) <= daysRemaining
    )
    .sort(
      (a, b) => Number(b.days_before_departure) - Number(a.days_before_departure)
    );

  if (applicable.length > 0) return applicable;

  return [
    {
      installment_number: 1,
      installment_percentage: 0,
      days_before_departure: 0,
    },
  ];
};
